import { Route } from 'react-router';
import {
  Page,
} from '@roc/feature-app-core';
import { InternalValuation } from '../internalValuation';

export const getInternalValuationRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    internalValuation: {
      path: `${basePath}/internal-valuation`,
      url: `${baseUrl}/internal-valuation`,
      documentTitle: 'Internal Valuation',
    },
  };
};

export const getInternalValuationRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getInternalValuationRoutesConfig(basePath, baseUrl);
  return {
    internalValuation: (
      <Route exact path={config.internalValuation.path}>
        <Page routeDefinition={config.internalValuation}>
          <InternalValuation />
        </Page>
      </Route>
    ),
  };
};
